import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-h5" }, "Trashed Posts", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Trashed posts are permanently deleted 30 days after they have been trashed. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_trashed_posts_toolbar = _resolveComponent("trashed-posts-toolbar")!
  const _component_posts_view_options = _resolveComponent("posts-view-options")!
  const _component_posts = _resolveComponent("posts")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-px-md" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode(_component_trashed_posts_toolbar, {
        "account-id": _ctx.accountId,
        "client-id": _ctx.clientId,
        filters: _ctx.filters,
        "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters) = $event)),
        "onUpdate:clientId": _ctx.selectClient
      }, null, 8, ["account-id", "client-id", "filters", "onUpdate:clientId"]),
      _createVNode(_component_posts_view_options, {
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
        "pagination-mode": _ctx.paginationMode,
        "onUpdate:paginationMode": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paginationMode) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_trashed_posts_toolbar, {
            "account-id": _ctx.accountId,
            "client-id": _ctx.clientId,
            filters: _ctx.filters,
            "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event)),
            "maximize-btn": {flat: true},
            minimized: "",
            "onUpdate:clientId": _ctx.selectClient
          }, null, 8, ["account-id", "client-id", "filters", "onUpdate:clientId"])
        ]),
        _: 1
      }, 8, ["filters", "pagination-mode"]),
      (_ctx.filters.socialSiteIds.length)
        ? (_openBlock(), _createBlock(_component_posts, {
            key: 0,
            filters: _ctx.filters,
            persist: _ctx.paginationMode === 'scroll',
            "infinite-scroll": _ctx.paginationMode === 'scroll',
            "new-page-top": _ctx.paginationMode === 'manual'
          }, null, 8, ["filters", "persist", "infinite-scroll", "new-page-top"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}